export default __webpack_public_path__ + "static/media/paid-parking-icon.279044c5.svg";